<script setup lang="ts">
    import type { HTMLAttributes } from 'vue';
    import { reactiveOmit } from '@vueuse/core';
    import { CollapsibleContent, type CollapsibleContentProps } from 'reka-ui';
    import { cn } from '@/lib/utils';

    const props = defineProps<CollapsibleContentProps & { class?: HTMLAttributes['class'] }>();

    const delegatedProps = reactiveOmit(props, 'class');
</script>

<template>
    <CollapsibleContent
        data-slot="collapsible-content"
        v-bind="props"
        class="data-[state=open]:animate-slideDown data-[state=closed]:animate-slideUp overflow-hidden"
    >
        <div :class="cn('pt-0', props.class)">
            <slot />
        </div>
    </CollapsibleContent>
</template>
